import { BoxProps, ColorOptions } from '@jfs/ui-new'
import { TextProps } from 'react-native'

const compShadow = {
  shadowColor: '#3a3b45',
  shadowOffset: {
    width: 0,
    height: 0,
  },
  shadowOpacity: 0.2,
  shadowRadius: 30,
  elevation: 3,
}

const styles = {
  compContainer: {
    padding: 24,
    overflow: 'auto',
    flex: 1,
    nativeID: 'hv-scroll',
  } as BoxProps,
  loadingStyle: {
    marginTop: 24,
    padding: 24,
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  } as BoxProps,
  labelText: {
    type: 'callout',
    color: 'DARK_GREY',
    textAlign: 'center',
  } as TextProps,
  menuView: {
    zIndex: 2,
    height: '100%',
    backgroundColor: 'TRANSPARENT' as ColorOptions,
    w: 224,
  } as BoxProps,
  title: { fontSize: 12, letterSpacing: 1.6, color: 'DARK_GREY' } as TextProps,
  menuViewContainer: {
    zIndex: 1,
    overflow: 'visible',
  } as BoxProps,
  menuContentView: (isLargeScreen: boolean) =>
    ({
      flex: 1,
      overflow: 'auto',
      zIndex: 1,
      height: '100vh',
    } as BoxProps),
  container: {
    height: '100vh',
    overflow: 'hidden',
    flexDirection: 'row',
    justifyContent: 'center',
    backgroundColor: 'LIGHT_GREY_SEPARATOR',
    flex: 1,
  } as BoxProps,
  containerInner: { flex: 1, height: '100vh' } as BoxProps,
  headerContainer: {
    ...compShadow,
    width: '100%',
    justifyContent: 'space-between',
    flexDirection: 'row',
    alignItems: 'center',
    ph: 16,
    h: 70,
    backgroundColor: 'WHITE',
    zIndex: 5,
  } as BoxProps,
  seactionTitle: {
    color: 'BLUE_SHADE',
  } as TextProps,
  pathName: {
    fontSize: 'FONT_SIZE_MEDIUM',
    fontWeight: '300',
  } as TextProps,
  PathHeader: {
    paddingHorizontal: 20,
    paddingTop: 16,
    justifyContent: 'center',
  } as BoxProps,
  hoverContainer: {
    underlayColor: 'TRANSPARENT',
    flexDirection: 'row',
    align: 'center',
    ph: 16,
    pv: 4,
  } as BoxProps,
  modalContainer: {
    ...compShadow,
    bg: 'WHITE',
    pv: 12,
    borderRadius: 4,
    top: 56,
    right: 12,
    position: 'absolute',
    zIndex: 29999,
    borderColor: 'GREY_1_SEPARATOR',
    borderWidth: 1,
    w: 160,
  } as BoxProps,
  searchContainer: {
    backgroundColor: 'WHITE',
    alignItems: 'center',
    marginVertical: 8,
    ml: 5,
    shadowOffset: { width: 0, height: 2 },
    shadowRadius: 3,
    shadowColor: '#0000001F' as ColorOptions,
    borderRadius: 4,
    zIndex: 4,
  } as BoxProps,
}

export default styles
